import React from 'react';
import { useSelector } from 'react-redux';

const TopLinks = () => {
  const { topLink } = useSelector((state) => state.navigation);
  return (
      <div className="top-link">
        {topLink &&
          topLink.map((link, index) => {
            return (
              <a key={'topLink-a' + index} href={link.href} title={link.text}>
                {link.text}
              </a>
            );
          })}
      </div>
  );
};

export default TopLinks;
